import { FC } from 'react';
import { Form, AutoComplete } from 'antd';
import usePlacesAutocomplete, { getGeocode, getLatLng, getZipCode } from 'use-places-autocomplete';
import { NamePath } from 'antd/lib/form/interface';
import { Rule } from 'antd/lib/form';
import { IAddress } from '../constants';

interface IFormItemPlacesAutoCompleteProps {
  label?: React.ReactNode;
  name?: NamePath;
  rules?: Rule[];
  onSetFieldsValue: (val: any) => void;
}

export const FormItemPlacesAutoComplete: FC<IFormItemPlacesAutoCompleteProps> = ({
  label,
  name,
  rules,
  onSetFieldsValue,
}) => {
  const {
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {},
    debounce: 300,
  });

  const handleAddressChange = (val: any) => {
    setValue(val);
  };

  const handleAddressSelect = ({ description }: any) => {
    // When user selects a place, we can replace the keyword without request data from API
    // by setting the second parameter to "false"
    // setValue(description, false);
    clearSuggestions();

    // Get latitude and longitude via utility functions
    getGeocode({ address: description })
      .then(async (results) => {
        const latLng = await getLatLng(results[0]);
        const zipCode = await getZipCode(results[0], false);
        return { ...latLng, zipCode };
      })
      .then(({ lat, lng, zipCode }) => {
        const address: IAddress = {};
        address.formattedAddress = description;
        address.latitude = lat;
        address.longitude = lng;
        address.zipCode = zipCode;
        address.postCode = zipCode;

        onSetFieldsValue({ address });
      })
      .catch(() => {
        // console.log("😱 Error: ", error);
      });
  };

  return (
    <Form.Item label={label} name={name} rules={rules}>
      <AutoComplete
        className="custom-input"
        value={value}
        onChange={handleAddressChange}
        placeholder="Enter first line of your address"
      >
        {status === 'OK' &&
          data.map((suggestion) => {
            const {
              place_id,
              structured_formatting: { main_text, secondary_text },
            } = suggestion;
            return (
              <AutoComplete.Option
                className="places-options"
                key={place_id}
                onClick={() => handleAddressSelect(suggestion)}
                value={`${main_text} ${secondary_text || ''}`}
              >
                <div key={place_id} onClick={() => handleAddressSelect(suggestion)}>
                  <strong>{main_text}</strong> <small>{secondary_text}</small>
                </div>
              </AutoComplete.Option>
            );
          })}
      </AutoComplete>
    </Form.Item>
  );
};
